import { EAuthenticationActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setAuthenticationSucceed = actionGenerator<EAuthenticationActionType.Succeed>(
  EAuthenticationActionType.Succeed,
);
export const setAuthenticationCancelled = actionGenerator<EAuthenticationActionType.Cancelled>(
  EAuthenticationActionType.Cancelled,
);
